import { Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { CustomMatSvgIconDirective } from '../custom-mat-svg-icon/custom-mat-svg-icon.directive';
import { availableIcons } from '../../../fonts/typing';

@Component({
  selector: 'app-icon-browser',
  templateUrl: './icon-browser.component.html',
  host: {
    class: 'w-full',
  },
  imports: [MatIcon, CustomMatSvgIconDirective],
})
export class IconBrowserComponent {
  readonly availableIcons = availableIcons;
}
